// extracted by mini-css-extract-plugin
module.exports = {"modals":"styles_modals__1sLlC","fullwidth":"styles_fullwidth__1smy9","narrow":"styles_narrow__1b001","buttons":"styles_buttons__1MW_E"};